import * as React from 'react';
import { ClaimService, UserService } from 'services/ApiService';
import { ClaimType, UserType } from 'types';

type AssignFormProps = {
  claimType: ClaimType,
  id: number,
  default: number
  disabled?: boolean;
};

type AssignFormState = {
  loading: boolean,
  default: number | undefined,
  users: { id: number, name: string }[],
  input: number | undefined,
};

/**
 * Form for assigning users for a claim
 */
class AssignForm extends React.Component<AssignFormProps, AssignFormState> {
  constructor(props: AssignFormProps) {
    super(props);
    this.state = {
      loading: true,
      default: props.default,
      users: [],
      input: props.default
    };

    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  async componentDidMount() {
    const users = await UserService.getAllUsers();
    const assignableUsers = users.filter((user) => (UserType.isAssignable(user.type)));
    this.setState({
      loading: false,
      users: assignableUsers.map((user) => ({ id: user.id, name: user.contactName }))
    });
  }

  handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    let newInput = (event.target as HTMLSelectElement).value 
      ? Number((event.target as HTMLSelectElement).value) 
      : undefined;
    this.setState({ input: newInput });
  }

  async submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (this.state.input === undefined) {
      await ClaimService.unassign(this.props.claimType, this.props.id);
    } else {
      await ClaimService.assign(this.props.claimType, this.props.id, this.state.input);
    }
    this.setState({ default: this.state.input });
  }

  checkDisabled() {
    return this.props.disabled;
  }

  render() {
    const isDisabled = this.checkDisabled();
    return (
      <form onSubmit={this.submit}>
        <label>
          {
            this.state.loading ? null :
              <>
                <select
                  value={this.state.input || ''}
                  onChange={this.handleChange}
                  disabled={isDisabled}
                >
                  <option value={undefined} />
                  {
                    this.state.users.map((user) => (
                      <option
                        value={user.id}
                        key={user.id}
                      >
                        {user.name}
                      </option>
                    ))
                  }
                </select>
                <button 
                  type="submit" 
                  value="submit" 
                  disabled={isDisabled || this.state.default === this.state.input}
                > 
                  {isDisabled || this.state.default === this.state.input ? 'Saved' : 'Save'} 
                </button>
              </>
          }
        </label>
      </form>
    );
  }
}
export default AssignForm;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AssignForm/index.tsx